import { render } from "./AdminSettingsView.vue?vue&type=template&id=4aa9a44b&ts=true"
import script from "./AdminSettingsView.vue?vue&type=script&lang=ts"
export * from "./AdminSettingsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__